import { render, staticRenderFns } from "./item-name.vue?vue&type=template&id=21c9daa8&scoped=true&"
import script from "./item-name.vue?vue&type=script&lang=js&"
export * from "./item-name.vue?vue&type=script&lang=js&"
import style0 from "./item-name.vue?vue&type=style&index=0&id=21c9daa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c9daa8",
  null
  
)

export default component.exports